import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class ChequeEnquiryService {
  constructor(private http: HttpUtilService) {}

  getChequeDetails(chequeNumber: string): Observable<any> {
    return this.http.get(
      `AmmendChequePurposeService.asmx/GetChequeDetails?chequeNumber=${chequeNumber}`
    );
  }
}